import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import { Row, Upload, Button, Typography } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTransferCustomerUpload } from "modules/transfer_customer_upload/store";
import { isEmpty } from "lodash";
import { sampleData } from "modules/utilities/utility";
const { Link } = Typography;
import { useToast } from "modules/navbar/top/store/toasterStore";

function TransferCustomerUpload() {
  const [disableButton, setDisableButton] = useState(true);
  const [fileData, setFileData] = useState({});
  const [totalEnteries, setTotalEnteries] = useState(0);
  const [totalReps, setTotalReps] = useState(0);
  const [totalInvalidEnteries, setTotalInvalidEnteries] = useState(0);
  const [message, setMessage] = useState("");
  const { setToaster } = useToast();

  const {
    validateData,
    validateLoading,
    uploadLoading,
    getValidateData,
    postTransferCustomerUpload,
  } = useTransferCustomerUpload();

  useEffect(() => {
    if (!isEmpty(validateData)) {
      setDisableButton(false);
      setTotalEnteries(validateData.count);
      setTotalInvalidEnteries(validateData?.incorrectEmailsList?.length);
      setTotalReps(() => {
        if (validateData && validateData.medrepsList) {
          const set1 = new Set([...validateData?.medrepsList]);
          return set1.size;
        }
        return 0;
      });
    } else {
      setDisableButton(true);
      setTotalEnteries(0);
      setTotalInvalidEnteries(0);
      setTotalReps(0);
    }
  }, [validateData]);

  const downloadCSV = async (status, downloadData, csvName) => {
    try {
      const csvString = downloadData
        .map((rowObject) => Object.values(rowObject).join(","))
        .join("\n");

      const url = window.URL.createObjectURL(
        new Blob([csvString], { type: "text/csv" })
      );
      let anchorTag = document.createElement("a");
      anchorTag.href = url;
      anchorTag.target = "_blank";
      anchorTag.download = csvName;
      document.body.appendChild(anchorTag);
      anchorTag.click();
      return Promise.resolve("success");
    } catch (error) {
      setMessage("download error");
    }
  };

  const downloadSample = async (event) => {
    const _fileName = `sample.csv`;
    await downloadCSV(event, sampleData, _fileName);
  };

  const validateTransfer = async (_file) => {
    let file = new FormData();
    file.append("file", _file);
    getValidateData(file);
  };

  const handleFileUpload = (info) => {
    if (info.fileList.length !== 0) {
      validateTransfer(info.file);
      setFileData(info.file);
    }
  };

  const beforeUpload = (file) => {
    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      setMessage(`only csv file allowed`);
      return true;
    }
    return false;
  };

  const transfer_customer = async () => {
    setFileLoading(true);
    let file = new FormData();
    file.append("file", fileData);
    postTransferCustomerUpload(file, setToaster);
  };

  const handleConfirm = () => {
    transfer_customer();
  };
  const handleRemoveFile = () => {
    setTotalEnteries(0);
    setTotalReps(0);
    setTotalInvalidEnteries(0);
    setDisableButton(true);
  };

  return (
    <div>
      <CardDiv
        style={{ height: "40vh" }}
        title={
          <div className="d-flex align-items-center">
            <div>Transfer Customer Upload</div>
            {message ? (
              <div className="text-warning" style={{ marginLeft: "26%" }}>
                {message}
              </div>
            ) : null}
          </div>
        }
        component={
          <div>
            <div className="d-flex flex-column">
              <Row justify="center" className="mt-4">
                <div className="flex flex-col gap-2">
                  <Upload
                    accept=".csv"
                    name="file"
                    beforeUpload={(file) => beforeUpload(file)}
                    onChange={handleFileUpload}
                    maxCount={1}
                    onRemove={handleRemoveFile}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <Link underline onClick={downloadSample}>
                    Download Sample
                  </Link>
                </div>
                <Button
                  type="primary"
                  disabled={
                    disableButton || totalInvalidEnteries > 0 || !totalEnteries
                  }
                  loading={uploadLoading}
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </Row>
              <Row justify="center" className="mt-16">
                {totalInvalidEnteries > 0 && (
                  <div className="text-danger">
                    Invalid CSV file. Please correct and re-upload
                  </div>
                )}
              </Row>
            </div>
            <div className="d-flex gap-5 mt-4">
              <div className="flex-1">
                <CardDiv
                  title={<div>Notes:</div>}
                  component={
                    <div>
                      <div>
                        1. Please upload a CSV file that contains the
                        customer_email and rep_email.
                      </div>
                      <div>
                        2. This is one time process that runs as a job, so once
                        submitted, it cannot be stopped.
                      </div>
                      <div>
                        3. An email is sent to ops@tatva.health once the process
                        is completed.
                      </div>
                      <div>
                        4. Please note that Macintosh CSV format is not
                        supported.
                      </div>
                    </div>
                  }
                />
              </div>
              <div className="flex-1">
                <div>
                  <CardDiv
                    title={<div>Summary:</div>}
                    component={
                      <div className="">
                        <div className="d-flex py-1 justify-content-between">
                          <div>Total Entries in the uploaded file</div>
                          <div>{totalEnteries}</div>
                        </div>

                        <div className="d-flex py-1 justify-content-between">
                          <div>Total Reps in the file</div>
                          <div>{totalReps}</div>
                        </div>

                        <div className="d-flex py-1 justify-content-between">
                          <div>Total Invalid entries</div>
                          <div>{totalInvalidEnteries}</div>
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default TransferCustomerUpload;
